import React from 'react';
import PoweredByUpshow from '../../assets/PoweredByUpshow';
import { bodyFontSizesBOH, titleFontSizesBOH } from '../../helpers/utils';
import { Textfit } from 'react-textfit';
export default function SideBar({
  logo,
  text,
  fontFamily,
  accent_color,
  accent_text_color,
  hide_poweredbyupshow
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "SideBar",
    style: {
      '--accent-color': accent_color,
      '--accent-text-color': accent_text_color
    }
  }, logo && /*#__PURE__*/React.createElement("img", {
    src: logo,
    className: "logo",
    alt: "logo"
  }), /*#__PURE__*/React.createElement("h2", {
    className: "text",
    style: {
      fontFamily,
      fontSize: titleFontSizesBOH.medium
    }
  }, /*#__PURE__*/React.createElement(Textfit, {
    key: 'message' + fontFamily,
    mode: "multi",
    min: bodyFontSizesBOH.small,
    max: titleFontSizesBOH.medium,
    style: {
      height: '400px',
      width: '500px',
      wordBreak: 'keep-all'
    }
  }, text)), !hide_poweredbyupshow && /*#__PURE__*/React.createElement(PoweredByUpshow, {
    className: "upshow-logo"
  }));
}